export interface Range {
  yearFrom: number;
  yearTo: number;
}

export interface Ranges {
  ranges: Range[];
}

export const EMPTY_RANGES: Ranges = { ranges: [] };

// Utility functions for Ranges
export const formatRanges = (ranges: Ranges): string => {
  return ranges.ranges
    .map(range => range.yearFrom === range.yearTo ?
      range.yearFrom.toString() :
      `${range.yearFrom} - ${range.yearTo}`)
    .join(', ') || '';
};

export const parseRangesText = (text: string): Ranges => {
  if (!text.trim()) return EMPTY_RANGES;

  try {
    const ranges = text.split(',').map(part => {
      const trimmed = part.trim();
      if (trimmed.includes('-')) {
        const [from, to] = trimmed.split('-').map(s => parseInt(s.trim()));
        if (isNaN(from) || isNaN(to)) return null;
        return { yearFrom: from, yearTo: to };
      } else {
        const year = parseInt(trimmed);
        if (isNaN(year)) return null;
        return { yearFrom: year, yearTo: year };
      }
    })
      .filter(range => range !== null)
      .map(range => range as Range);

    if (ranges.length === 0) return EMPTY_RANGES;
    return { ranges };
  } catch (error) {
    console.error('Error parsing ranges text:', error);
    return EMPTY_RANGES;
  }
};

export interface DateRangeValidationRequest {
  specification: string;
}

export interface DateRangeValidationResponse {
  valid: boolean;
  ranges: Ranges;
}
